

<template>
	<div class="big-button" v-bind:data-index="index" :class="{current:isCurrent}">
		<a @click="onClick" class="link px-5 py-2 mb-2 mb-lg-5" :class="{disabled:disabled}">
			<slot></slot>
		</a>
	</div>
</template>

<script>

import { EventBus } from '@/common/eventbus.js';
import { mapState } from 'vuex';

export default {
	props: ['disabled', 'link', 'index', 'node'],
	data: () => {
		return {
		}
	},
	computed: {
		...mapState('navigation', ['current']),
		isCurrent() {
			return this.current.url == this.link
		}
	},
	methods: {
		onClick() {
			EventBus.$emit('nav-clicked', {
				link: this.link,
				node: this.node,
			});
		}
	}

}
</script>

<style scoped lang="scss">
	
	$box-depth: 0.9rem;
	$box-hover-depth: 0.6rem;
	
	.big-button {
		white-space: nowrap;
		.link {
			color: #f6ffff;
			font: 1rem/1 $font-condensed;
			font-weight: 600;
			letter-spacing: 0.02em;
			text-transform: uppercase;
			background-color: #5abfbe;
			display: inline-block;
			position: relative;
			transform: skewY(-26deg) scaleX(0.9) translate(0, 100px);
			transform-origin: top left;
			transition: 0.2s all;
			cursor: pointer;
			user-select: none;
			@media ($min-device-width-lg) {
				font-size: 1.4rem;
			}
			@media ($min-device-width-xxl) {
				font-size: 1.75rem;
			}
			&:before {
				content:'';
				position: absolute;
				top: -4px;
				height: 4px;
				@media ($min-device-width-lg) {
					top: -#{$box-depth};
					height: #{$box-depth};
				}
				left: 0;
				right: 0;
				background-color: #009e92;
				transform: skewX(50deg) scaleY(0.85);
				transform-origin: bottom right;
				transition: 0.2s all;
			}
			&:after {
				content:'';
				position: absolute;
				left: -4px;
				width: 4px;
				@media ($min-device-width-lg) {
					left: -#{$box-depth};
					width: #{$box-depth};
				}
				top: 0;
				bottom: 0;
				background-color: #cbebec;			
				transform: skewY(40deg);
				transform-origin: bottom right;
				transition: 0.2s all;
			}
		}
		&.current,
		&:hover {
			@media ($min-device-width-lg) {
				.link {
					transform: skewY(-26deg) scaleX(0.9) translate(-5px, 95px);
				}
				.link:before {
					top: -$box-hover-depth;
					height: $box-hover-depth;
				}
				.link:after {
					left: -$box-hover-depth;
					width: $box-hover-depth;
				}
			}
		}

		&.current .link {
			background-color: lighten(#5abfbe, 20%);
		}
	}

	.pflege .big-button {
		.link {
			background-color: #80cae3;
			&:before {
				background-color: #1b9fcc;
			}
			&:after {
				background-color: #e4f3f9;
			}
		}
		&.current .link {
			background-color: lighten(#80cae3, 10%);
		}
	}

</style>
